import { Controller } from 'stimulus'

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.loaded = false
  }

  load() {
    if (this.loaded || !this.urlValue) return

    this.loaded = true

    fetch(this.urlValue, { headers: { Accept: 'application/json' } })
      .then((response) => (response.ok ? response.json() : Promise.reject()))
      .then((names) => this.populate(names))
      .catch(() => {
        // retry on next focus if it failed
        this.loaded = false
      })
  }

  populate(names) {
    const list = this.element.list
    if (!list) return

    list.innerHTML = ''
    names.forEach((name) => {
      const option = document.createElement('option')
      option.value = name
      list.appendChild(option)
    })
  }
}
